import React, { Component } from 'react';
import { formatCurrency } from '@C/TableGrid';

class OtherExpense extends Component {
  constructor() {
    super();
  }

  render() {
    const summary = this.props.summary;
    return (
      <>
        <section className="widget dsr-table">
          <header></header>
          <main>
            <table className="dsr" data-name="Other Expense">
              <thead>
                <tr>
                  <th colSpan={2} className="alert-brand">
                    {' '}
                    Other Expense
                  </th>
                </tr>
                <tr data-header={true}>
                  <th> Description </th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {summary.map((item, key) => {
                  return (
                    <tr key={key}>
                      <td>{item.expense_type}</td>
                      <td>{formatCurrency(item.amount || 0)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </main>
        </section>
      </>
    );
  }
}

export default OtherExpense;
